/*----- Core -----*/
import React     			 from 'react'
import styled, { css } from 'styled-components'
import PropTypes 			 from 'prop-types'

/*----- Ant design -----*/
import { Row, Col } from 'antd'

/*----- Commons -----*/
import Device from '../../commons/Device'

const StyledSectionContainer = styled.section`
	width: 100%;
	display: flex;
	justify-content: center;
	padding: 64px 16px;
	${props => props.xl && css`
		@media ${ Device.md } {
			padding: 128px 0;
		}
  `}
	${props => props.noSpacing && css`
		padding: 0px 16px !important;
  `}
`

/*----- Export -----*/
const SectionContainer = ({ children, xl, noSpacing }) => {
	return (
		<StyledSectionContainer className="section-container" xl={xl} noSpacing={noSpacing}>
			<Row style={{width: '100%'}}>
				<Col xs={24} sm={{ span: 24 }} md={{ span: 20, offset: 2 }} lg={{ span: 20, offset: 2 }} xl={{ span: 20, offset: 2 }}>
					{ children }
				</Col>
			</Row>
		</StyledSectionContainer>
	)
}
export default SectionContainer

/*----- PropTypes -----*/
SectionContainer.propTypes = {
  children: PropTypes.node.isRequired
}
